
import {SpawnQiBalls, QiBall} from './qiball'
import {FairyField} from './fairyfield'
import {NeuralField} from './neuralfield.js'
import {Vector2} from './vector'
import { MidiMaestro } from './midi'

// blasts leave behind lines
//which pulsate and send energy

export const canvas = document.querySelector('canvas')
export const ctx = canvas.getContext('2d')

canvas.width = innerWidth
canvas.height = innerHeight




let qiBalls = SpawnQiBalls();

let fairyFields = [];

let neuralfield = new NeuralField(ctx);

const mouse = {
  x: innerWidth / 2 ,
  y: innerHeight / 2
}

let midiMaestro = new MidiMaestro();


export const colors = ['#ff7c38', '#e03e36', '#b80d57', '#700961']

// Event Listeners
addEventListener('mousemove', (event) => {
  mouse.x = event.clientX
  mouse.y = event.clientY
})

addEventListener('mousedown', (event)=> {
  let position = new Vector2( event.clientX, event.clientY)
   //midiMaestro.addSubscriber(qiBall);

  let fairyField = new FairyField(ctx, position);
  fairyFields.push(fairyField);
})

addEventListener('mouseup', (event)=> {
  //fairyField.rise();
}) 

addEventListener('keydown', (event) => {
  if(event.key === 'b') {
    qiBalls.forEach (qiBall => qiBall.blast());
  }
});


addEventListener('resize', () => {
  canvas.width = innerWidth
  canvas.height = innerHeight

})

// Animation Loop
function animate() {
  requestAnimationFrame(animate)
  ctx.fillStyle = "black";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  //ctx.fillStyle = colors[3];
  //ctx.fillRect(0, 0, canvas.width, canvas.height)

  neuralfield.update();
  qiBalls.forEach(qiBall => qiBall.update())
 // fairyFields.forEach (fairyField => fairyField.update());
  
}






animate()

